/**
 * Maps a field id to an oData field.
 * 
 * @param id Defines the field id.
 */
export const guidToODataFieldId = (id: string): string => {
    return `field${id.replace(/-/g, '')}`;
};
